// extracted by mini-css-extract-plugin
export var card = "_oj-0";
export var content = "_oj-2";
export var details = "_oj-3";
export var icon = "_oj-1";
export var iconBlue = "_oj-5";
export var iconBrand = "_oj-4";
export var iconGrayBlue = "_oj-6";
export var iconGreen = "_oj-7";
export var iconIndigo = "_oj-8";
export var iconOrange = "_oj-9";
export var iconPurple = "_oj-a";
export var iconRed = "_oj-b";
export var iconWarning = "_oj-c";